import {
  CUSTOMER_LINKS_REQUEST,
  CUSTOMER_LINKS_SUCCESS,
  CUSTOMER_LINKS_FAILURE,
} from './types';

const defaultState = {
  is_fetching: false,
  data: null,
  error: null,
};

// eslint-disable-next-line default-param-last
export default (state = defaultState, action) => {
  switch (action.type) {
    case CUSTOMER_LINKS_REQUEST:
      return { ...defaultState, is_fetching: true };
    case CUSTOMER_LINKS_SUCCESS:
      return { ...defaultState, data: action.brandCustomerLinks };
    case CUSTOMER_LINKS_FAILURE:
      return { ...defaultState, error: action.error };
    default:
      return state;
  }
};
